import axios from "axios";
import {
    GET_ERRORS,
    USER_ADD,
    USER_UPDATE,
    CRYPTO_UPDATE
} from "./types";
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl;

export const addCrypto = (CryptoData, history) => dispatch => {
    axios
        .post(baseUrl + "/api/v1/addCryptocoin", CryptoData)
        .then(res =>
            dispatch({
                type: 'CRYPTO_ADD',
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};


export const updateCrypto = (CryptoData) => dispatch => {
    axios
        .put(baseUrl + "/api/v1/updatecoins", CryptoData)
        .then(res =>
            dispatch({
                type: CRYPTO_UPDATE,
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};
